(function () {
  'use strict';

  // Auto-focus search input when page loads on /search
  if (window.location.pathname === '/search') {
    document.addEventListener('DOMContentLoaded', function () {
      var input = document.getElementById('tm-search-input');
      if (input) {
        setTimeout(function () { input.focus(); }, 100);
      }
    });
  }

  // Persist search query in URL on submit
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== 'tm-search-form') return;
    var input = form.querySelector('input[name="q"]');
    if (input && input.value.trim()) {
      var url = new URL(window.location.origin + '/search');
      url.searchParams.set('q', input.value.trim());
      url.searchParams.set('type', 'product');
      window.history.replaceState({}, '', url.toString());
    }
  });

  // Enter key always submits search form to full results page
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var active = document.activeElement;
    if (!active) return;
    if (active.getAttribute('name') === 'q' || active.id === 'tm-search-input') {
      e.preventDefault();
      var form = active.closest('form');
      if (form) {
        form.submit();
      } else {
        var q = active.value.trim();
        if (q) window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
      }
    }
  });

  // Prevent overlay interception on search result cards
  document.addEventListener('DOMContentLoaded', function () {
    var grid = document.getElementById('SearchProductGrid');
    if (!grid) return;

    grid.addEventListener('click', function (e) {
      var card = e.target.closest('.tm-card-wrapper');
      if (!card) return;
      var btn = e.target.closest('.tm-card__atc-btn, button, a');
      if (btn) return;
      var link = card.querySelector('a[href*="/products/"]');
      if (link) {
        window.location.href = link.href;
      }
    }, false);
  });

  // Debounce predictive search
  var patchAttempts = 0;
  function patchPredictiveSearch() {
    var el = document.querySelector('predictive-search');
    if (!el || !el.onChange) {
      if (patchAttempts < 5) {
        patchAttempts++;
        setTimeout(patchPredictiveSearch, 600);
      }
      return;
    }
    if (el._tmDebounced) return;
    el._tmDebounced = true;
    var original = el.onChange.bind(el);
    var timer = null;
    el.onChange = function () {
      clearTimeout(timer);
      timer = setTimeout(original, 280);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchPredictiveSearch);
  } else {
    patchPredictiveSearch();
  }

})();
